const dataProposeTLRoute = [
  {
    desc: "proposedTLRoute",
    coord: [
      // { lat: -2.844615288030678, lng: 122.0808162215605 },
      // { lat: -2.843626065557394, lng: 122.0808581604368 },
      // { lat: -2.842561916832862, lng: 122.0835809703182 },
      // { lat: -2.841683869208673, lng: 122.0870592412189 },
      // { lat: -2.842930810426423, lng: 122.0954786352646 },
      // { lat: -2.837476413586116, lng: 122.1013152926669 },
      // { lat: -2.828609591574998, lng: 122.108910416868 },
      // { lat: -2.827088504528595, lng: 122.1202308164921 },
      // { lat: -2.829230982549955, lng: 122.1328643341851 },
      // { lat: -2.829537642082105, lng: 122.1429807751129 },
      // { lat: -2.838550870239782, lng: 122.1429912846695 },
      // { lat: -2.842895570101015, lng: 122.1519798356979 },      
      { lat: -2.8432491071980666, lng: 122.07738367307412 },
      { lat: -2.8444174522523964, lng: 122.07915507342156 },
      { lat: -2.846509617111859, lng: 122.08234721153664 },
      { lat: -2.8469633223642945, lng: 122.08411019106379 },
      { lat: -2.847634808571461, lng: 122.08672768169151 },
      { lat: -2.8458369339642533, lng: 122.08958102855628 },
      { lat: -2.8436143943862637, lng: 122.09307346010891 },
      { lat: -2.8421959391292377, lng: 122.09530572833388 },
      { lat: -2.840343815118561, lng: 122.09823106760405 },
      { lat: -2.837326182136864, lng: 122.1029926051942 },
      { lat: -2.8361787505081684, lng: 122.10480180461025 },
      { lat: -2.8343717666885935, lng: 122.10765511092676 },
      { lat: -2.8322485377726725, lng: 122.11099446630209 },
      { lat: -2.830775923475331, lng: 122.11344265639418 },
      { lat: -2.8301886863248167, lng: 122.1144237289323 },
      { lat: -2.828417915072808, lng: 122.11735795190887 },
      { lat: -2.8283597309131614, lng: 122.12410542600752 },
      { lat: -2.8298674003675734, lng: 122.13208428122829 },
      { lat: -2.8333435502898694, lng: 122.13536546867863 },
      { lat: -2.835778658990537, lng: 122.13765781168138 },
      { lat: -2.837916984848513, lng: 122.14228052774722 },
      { lat: -2.8398922007774416, lng: 122.14654351592368 },
      { lat: -2.8411606793350623, lng: 122.1492775926531 },
      { lat: -2.842202655513182, lng: 122.15154401100328 },
      { lat: -2.842737218155417, lng: 122.15268620895567 },
      
      

    ],
  },
];

export default dataProposeTLRoute;
